<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-lighter`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 6.11V2.09C12.787 3.1 4 12.524 4 24s8.787 20.9 20 21.91v-4.02C15 40.896 8 33.265 8 24S15 7.104 24 6.11zM43 6H31a1 1 0 00-1 1v2a1 1 0 001 1h12a1 1 0 001-1V7a1 1 0 00-1-1zM31 38h12a1 1 0 011 1v2a1 1 0 01-1 1H31a1 1 0 01-1-1v-2a1 1 0 011-1zm12-16H25a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1z"/></svg>
</template>
<script>

export default {
  name: 'IconLighter',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
